import { ca } from '@cian/analytics';

import { createDeveloperProduct } from 'shared/utils/analytics';

import { type CarouselBanner } from '../../Carousel';

/**
 * @description Событие: главная карусель (hero) попала в зону видимости.
 */
export function trackShowMainCarouselSection(banners: CarouselBanner[]): void {
  ca('eventSite', {
    action: 'show_landing_section',
    category: 'Promo',
    label: 'main_carousel',
    name: 'oldevent',
    products: [
      createDeveloperProduct({
        extra: {
          items: banners.map((banner, index) => ({
            id: banner.id,
            offerType: 'newbuilding_id',
            position: index,
          })),
        },
      }),
    ],
  });
}
